// Mixins
import BaseFormFieldsMixin from '@windsor-telecom-management/client-core/src/mixins/forms/base-form-fields.mixin'
import BaseFormEventsMixin from './base-form-events.mixin'
import BaseFormDataMixin from '@windsor-telecom-management/client-core/src/mixins/forms/base-form-data.mixin'
// Components
import BaseFormAlert from '../components/BaseFormAlert'
import BaseFormActions from '../components/BaseFormActions'
import BaseFormToolbar from '../components/BaseFormToolbar'
import BaseFormActionsContainer from '../components/BaseFormActionsContainer'
import BaseFormContainer from '../components/BaseFormContainer'

/**
 * Base form mixin which handles standard validation, events, and state management
 * @mixin
 */
export default {
    mixins: [BaseFormFieldsMixin, BaseFormDataMixin, BaseFormEventsMixin],
    props: {
        /**
         * Toggles the BaseLoadingContainer component
         * Useful when doing async actions before displaying the form fields
         */
        loading: {
            type: Boolean,
            default: false
        },
        /**
         * Sets the submit button in a loading state, and the close button
         * in a disabled state
         */
        saving: {
            type: Boolean,
            default: false
        }
    },
    components: {
        BaseFormAlert,
        BaseFormActions,
        BaseFormActionsContainer,
        BaseFormContainer,
        BaseFormToolbar
    },
    watch: {
        loading (newVal, oldVal) {
            if (!newVal && oldVal) {
                this.disablePrependIconTabIndex()
            }
        }
    },
    mounted () {
        const vm = this
        if (!vm.loading) {
            vm.disablePrependIconTabIndex()
        }
    }
}
